import { ColumnDefinition } from "@/types/column.types.ts";

export enum ApiEmployeeViewType {
  employee_list = "employee-list",
}

export interface ApiEmployeeViewColumns {
  columns: ColumnDefinition[];
}

export interface ApiEmployeeListView {
  id: number;
  type: string;
  title: string;
  sort: number;
  value: Record<string, unknown>;
  columns: ApiEmployeeViewColumns;
  is_default: boolean;
  datetime_created_at: Date;
  datetime_updated_at: Date;
}

export interface ApiEmployeeListViewCreate {
  type: string;
  title: string;
  value?: Record<string, unknown>;
  columns?: ApiEmployeeViewColumns;
}

export interface ApiEmployeeListViewUpdate {
  title?: string | null;
  value?: Record<string, unknown> | null;
  columns?: ApiEmployeeViewColumns | null;
}

export interface ApiEmployeeListViewReorder {
  type: string;
  view_ids: number[];
}
